import { apiGateway } from "@contexts";
import type { GetBankTransactionStatusResponse } from "@interfaces";
import { BankTransactionStatus } from "@interfaces";
import { useQuery } from "@tanstack/react-query";
import { millisecondsInSecond } from "date-fns";
import { isAxiosError } from "axios";

const BANK_TRANSFER_REJECTED_MESSAGE = "Bank transfer rejected";

const isBankTransferRejectedError = (error: unknown): boolean =>
  isAxiosError(error) &&
  error.response?.data &&
  typeof error.response.data === "object" &&
  "message" in error.response.data &&
  (error.response.data as { message?: string }).message ===
    BANK_TRANSFER_REJECTED_MESSAGE;

export const useVerifyBankTransferStatus = ({
  enabled = true,
}: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: ["transactionStatus"],
    enabled,
    queryFn: () =>
      apiGateway<GetBankTransactionStatusResponse>({
        url: "/enrolment/bank-transfer-challenge/verify",
        method: "GET",
      }),
    staleTime: 2 * millisecondsInSecond,
    refetchInterval: (query) => {
      if (isBankTransferRejectedError(query.state.error)) return false;
      const status = query.state.data?.bankTransferStatus;

      if (
        status === BankTransactionStatus.APPROVED ||
        status === BankTransactionStatus.REJECTED
      )
        return false;

      return 3 * millisecondsInSecond;
    },
  });
